// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__W1TTO","tertiaryBtn":"Button_tertiaryBtn__4TcXW","secBtn":"Button_secBtn__4zEsT","leftIcon":"Button_leftIcon__cnmlk","rightIcon":"Button_rightIcon__Myn8+"};